module.exports = __webpack_public_path__ + "img/animal-crossing.6eeac781.png";